<template>
  <div class="wind_speed_warper" :style="{ width:(width+120) + 'px' }">
    <div class="l_speed_img">
      <img src="../../../assets/img/controlpublic/kongtiao_difeng_active.png" alt />
    </div>
    <div class="wind_slider" :style="{ width:(width) + 'px' }" @click="barClick">
      <div class="wind_slider-bar" ref="elem">
        <div class="wind_slider_bar_show1"></div>
        <div class="wind_slider_bar_show2"></div>
        <div class="wind_slider_bar_show3"></div>
        <div
          class="wind_slider-handle"
          :style="{ left: (computedSliderHandlePos) + 'px' }"
          @mousedown="dragStart($event, 0)"
          @touchstart="dragStart($event, 0)"
        >
          <div class="wind_value_show_wraper">
            <span>{{ computedShowValue }}</span>
          </div>
        </div>
        <div class="wind_slider-process" :style="{ width: (computedSliderHandlePos) + 'px' }"></div>
      </div>
    </div>
    <div class="h_speed_img">
      <img src="../../../assets/img/controlpublic/kongtiao_gaofeng_active.png" alt />
    </div>

    <div
      class="wind_speed_btn public_control_click"
      :class=" windSpeed === 1 ? 'public_control_btn_on' : '' "
      @click="autoBtnClickHandle"
    >自动</div>
  </div>
</template>

<script>
export default {


  data: function() {
    return {
      position: 0, ///圆点的绝对定位位置
      positionOffset: 14, ////圆点大小一半的宽度，用来抵消移动位置时的偏移量
      dragging: false, ///拖拽的标志位
      fuWidth: null, ///为了显示负值，暂时不可取默认设置0
      offset: null, ///计算位置距离屏幕左边的偏移量  用来抵消，在组件创建时获取并付初值
      ValueBase: 1, ///  值与像素之间的倍数关系，组件挂载时获取
      value: null,
      windSpeed: this.setWindSpeed ////风速值
    };
  },
  props: {
    width: {
      ///进度条的宽度  父组件传递
      type: Number,
      default: 300
    },
    maxValue: {
      //显示的最大值  父组件传递
      type: Number,
      default: 100
    },
    // setValue: {
    //   //该变值和进度条位置的接口对象
    //   type: Number,
    //   default: 0
    // },
    setWindSpeed: {
      type: Number,
      default: 2
    }
  },
  computed: {
    computedSliderHandlePos() {
      ///圆点位置及进度条宽度的计算
      // console.log(this.position-this.positionOffset)
      if (this.position - this.positionOffset < 0) {
        ///宽度不能设置成负的 否则不生效
        return 0;
      }
      return this.position - this.positionOffset;
    },
    computedShowValue(){
      if (this.windSpeed === 1) return '自动'
      else if( this.windSpeed === 2 ) return '低速'
      else if( this.windSpeed === 4 ) return '中速'
      else if( this.windSpeed === 6 ) return '高速'
    }
  },
  watch: {
    setWindSpeed(val) {
      this.windSpeed = val;
      this.updataValue(val); /// 根据风速状态设置 进度条的值和当前位置
      this.$emit("windSpeedChange", this.windSpeed); ///并把当前值传递给父组件
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.width = parseInt(this.$refs.elem.offsetWidth); ///得到进度条的总宽度取整
      this.fuWidth = 0;
      this.ValueBase = this.width / this.maxValue; ////根据要显示的值计算出等分比例基数
      // console.log(this.width);
      this.offset = parseInt(this.$refs.elem.getBoundingClientRect().left); ///获取元素到视窗左边的距离 取整
      // this.updataPosition(this.value); //组件第一次加载时，根据父组件传来的value及时更新进度条位置

      this.updataValue(this.setWindSpeed); /// 根据风速状态设置 进度条的值和当前位置
    });
  },
  methods: {
    barClick: function(ev) {
      /////进度条的点击事件
      var pos = this.getPosition(ev); ///获取当前点击屏幕的位置并进行转换 成 圆点 slider-handle 应该在的位置
      this.setPosition(pos);
    },
    getPosition: function(ev) {
      // console.log(ev);
      if (ev.touches) {
        ////说明是触摸屏事件
        ///对获取到的当前屏幕的位置进行转换
        // console.log(ev.clientX); ////点击位置距离屏幕坐标
        // ev.clientX = ev.clientX-this.positionOffset
        if (ev.touches[0].clientX - this.offset < this.fuWidth) {
          ///小于了最小的下限宽度范围
          return this.fuWidth;
        } else if (ev.touches[0].clientX - this.offset > this.width) {
          ///大于了最大的上限宽度
          return this.width;
        }
        return ev.touches[0].clientX - this.offset;
      } else {
        ///说明是鼠标点击事件
        ///对获取到的当前屏幕的位置进行转换
        // console.log(ev.clientX); ////点击位置距离屏幕坐标
        // ev.clientX = ev.clientX-this.positionOffset
        if (ev.clientX - this.offset < this.fuWidth) {
          ///小于了最小的下限宽度范围
          return this.fuWidth;
        } else if (ev.clientX - this.offset > this.width) {
          ///大于了最大的上限宽度
          return this.width;
        }
        return ev.clientX - this.offset;
      }
    },
    setPosition: function(pos) {
      this.position = pos;
      this.value = parseInt(this.position / this.ValueBase); ///更新显示值
      this.computedWindSpeed(); ///根据进度条的值更新风速值，并把风速值传递给父组件
      // this.$emit("valueChange", this.value); ///并把当前值传递给父组件
    },
    dragStart: function() {
      ///鼠标点下了移动的圆点
      console.log("鼠标击下了");
      this.dragging = true; ///把点击的标志位置位

      this.bindListener(); //绑定鼠标点击圆点后的鼠标移动和鼠标点击后的松开事件
    },
    drag: function(ev) {
      // console.log("鼠标经过");
      if (!this.dragging) return; ///鼠标没有点下了移动的圆点
      this.barClick(ev); ///如果鼠标点下了圆点  鼠标移动相当于一直在点击进度条
    },
    dragEnd: function() {
      ////鼠标松开触发的事件
      console.log("鼠标松开了");
      this.dragging = false;
      this.removeListener(); //移除鼠标点击圆点后的鼠标移动和鼠标点击后的松开事件
    },
    bindListener: function() {
      //绑定鼠标点击圆点后的鼠标移动和鼠标点击后的松开事件
      document.addEventListener("mousemove", this.drag); ////绑定监听事件  鼠标经过
      document.addEventListener("mouseup", this.dragEnd); ////绑定监听事件  鼠标点击后松开
      /// 绑定触摸屏支持的监听事件
      document.addEventListener("touchmove", this.drag); ////绑定监听事件  触摸手指移动
      document.addEventListener("touchend", this.dragEnd); ////绑定监听事件  触摸手指松开了
    },
    removeListener: function() {
      //移除鼠标点击圆点后的鼠标移动和鼠标点击后的松开事件
      document.removeEventListener("mousemove", this.drag); ////移除监听事件  鼠标经过
      document.removeEventListener("mouseup", this.dragEnd); ////移除监听事件  鼠标点击后松开
    },
    updataPosition(value) {
      //根据父组件传来的value更新进度条位置
      if (value < this.fuWidth) {
        this.position = parseInt(this.fuWidth * this.ValueBase);
      } else if (value > this.maxValue) {
        this.position = parseInt(this.maxValue * this.ValueBase);
      } else {
        // console.log(this.ValueBase);
        this.position = parseInt(value * this.ValueBase);
      }
    },
    autoBtnClickHandle() {
      this.windSpeed = 1;
      this.value = 84;
      this.updataPosition(this.value); //组件第一次加载时，根据父组件传来的value及时更新进度条位置
      this.$emit("windSpeedChange", this.windSpeed); ///并把当前值传递给父组件
      console.log(this.windSpeed);
    },
    updataValue(windSpeed) {
      if (windSpeed === 2) {
        this.value = 16;
      } else if (windSpeed === 4) {
        this.value = 52;
      } else if (windSpeed === 6) {
        this.value = 84;
      } else {
        this.value = 84;
      }
      // console.log(this.value)
      this.updataPosition(this.value); //组件第一次加载时，根据父组件传来的value及时更新进度条位置
    },
    computedWindSpeed() {  ///根据进度条的值更新对应的风速值
      // console.log(this.value)
      if (this.value <= 34) {
        this.windSpeed = 2;
        this.value = 16;
      } else if (this.value >= 35 && this.value <= 67) {
        this.windSpeed = 4;
        this.value = 52;
      } else if (this.value >= 68 && this.value <= 100) {
        this.windSpeed = 6;
        this.value = 84;
      } else {
        this.windSpeed = "自动";
        this.value = 84;
      }
      this.updataPosition(this.value); //组件第一次加载时，根据父组件传来的value及时更新进度条位置
      this.$emit("windSpeedChange", this.windSpeed); ///并把当前值传递给父组件
      return;
    }
  }
};
</script>

<style>
.wind_speed_warper {
  height: 80px;
  position: relative;
  /* border: 1px solid black; */
  /* display:inline-block; */
}
.l_speed_img {
  width: 21px;
  height: 21px;

  display: inline-block;

  position: absolute;
  top: 45px;
}

.l_speed_img img {
  width: 100%;
  height: 100%;
}

.h_speed_img {
  width: 21px;
  height: 21px;

  display: inline-block;

  position: absolute;
  top: 45px;
  right: 65px;
}

.h_speed_img img {
  width: 100%;
  height: 100%;
}

.wind_speed_btn {
  display: inline-block;
  font-size: 14px;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;
  padding: 2px 7px;

  position: absolute;
  top: 42px;
  right: 0px;
}

.wind_slider {
  /* width: 248px; */
  padding: 0px 5px;

  position: absolute;
  top: 54px;
  left: 22px;
}

.wind_slider-bar {
  width: 100%;
  height: 6px;
  position: relative;
  display: block;
  border-radius: 15px;
  background-color: #777777;
}

.wind_slider_bar_show1 {
  width: 100%;
  height: 6px;

  position: absolute;

  background-color: #999;
  border-radius: 15px;
}
.wind_slider_bar_show2 {
  width: 3px;
  height: 6px;

  position: absolute;
  background-color: #777;

  left: 58px;
  z-index: 3;
}
.wind_slider_bar_show3 {
  width: 3px;
  height: 6px;

  position: absolute;
  background-color: #777;
  right: 58px;
  z-index: 3;
}

.wind_slider-handle {
  width: 24px;
  height: 24px;
  top: -10px;
  position: absolute;
  border-radius: 50%;
  background-color: #f5f5f5;
  box-shadow: 0px 4px 6px 0px rgba(255, 255, 255, 0.42);
  cursor: pointer;

  z-index: 4;
}

.wind_slider-handle:hover {
  width: 26px;
  height: 26px;
}
.wind_value_show_wraper {
  width: 50px;
  height: 25px;
  /* line-height: 25px; */
  background-color: #999999;
  border-radius: 5px;
  text-align: center;

  position: absolute;
  top: -34px;
  left: -12px;

  display: flex;
  justify-content: center;
  align-items: center;

}
.wind_value_show_wraper span{
  font-size: 14px;

}
.wind_value_show_wraper::after {
  content: "";
  /* width: 2px;
  height: 2px; */
  border: 5px solid;

  border-color: #999999 transparent transparent transparent;

  position: absolute;
  top: 25px;
  left: 20px;
}

.wind_slider-process {
  background-color: #f5f5f5;
  width: 0px;
  height: 6px;
  padding-right: 15px;
  border-radius: 15px;

  z-index: 2;
  position: relative;
}
</style>

